define('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyEmptyView',['require','marionette','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('marionette').LayoutView;
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    return Parent.extend({

        template: '#time_grid_weekly_empty_view',
        
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        serializeData: function () {
            var result = Parent.prototype.serializeData.apply(this);
            
            result.error_message = this.getOption('collectionError');
            result.is_loaded = this.getOption('isLoaded');

            return result;
        }

    });

});
